var render = function render(){var _vm=this,_c=_vm._self._c;return _c('masked-input',{ref:"input",attrs:{"type":"text","mask":_vm.createNumberMask,"guide":false},on:{"keypress":_vm.eventKeyPress,"focus":_vm.onFocus,"blur":_vm.handleBlur},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }